import { arrayUnion, doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import getFormSession from "../../../Components/CluppForms/getFormSession";
import saveFormRecord from "../../../Components/CluppForms/saveFormRecord";
import ToDoBetter from "./ToDoBetter";

const landingId = "CF_TO_DO_BETTER";

const onLoad = async ({ session, landedAt, uid, fieldsStructure }) => {
  const prevAnswers = {};
  let prevReview = "";
  const prevForm = await getFormSession("cancelation-form", session.sessionID);
  const landings = prevForm.items;

  landings.forEach((item) => {
    if (item.answers.length > 0) {
      const lastField = item?.answers[0];
      const fieldID = lastField.field.id;
      const lastFieldType = lastField.type;
      const lastFieldAnswers = lastField[lastFieldType]?.value;
      prevAnswers[fieldID] = lastFieldAnswers;
    }
  });
  const itemsFromThisLanding = prevForm.items.find(
    (items) => items.landingId === landingId
  );
  if (itemsFromThisLanding) {
    const thisField = itemsFromThisLanding?.answers[0];
    const thisFieldType = thisField.type; // choice
    prevReview = thisField[thisFieldType].value;
  }
  if (!prevReview) {
    const thisField = fieldsStructure[0];
    const thisFieldType = thisField.type;
    prevReview = thisField[thisFieldType].value;
  }
  return {
    userId: uid,
    ...prevAnswers,
    [fieldsStructure[0].field.id]: prevReview,
    landedAt,
    prevForm,
    sessionId: session.sessionID,
    currentLanding: landingId,
  };
};

const onSubmit = async ({
  state,
  session,
  fieldsStructure,
  nextPage,
  navigate,
}) => {
  if (session?.sessionID) {
    try {
      const path = `IT/forms/cancelation-form/${session.sessionID}`;
      const docRef = doc(db, path);
      const prevForm = state.prevForm;

      const newLanding = {
        landingId,
        landedAt: state.landedAt,
        submittedAt: Date.now(),
      };

      const answerStructure = fieldsStructure[0];
      const fieldType = answerStructure.type;
      const filedName = answerStructure.field.id;
      answerStructure[fieldType].value = state[filedName];
      newLanding.answers = [answerStructure];

      const thisItemExists = prevForm.items.find(
        (item) => item.landingId === landingId
      );

      const updateData = thisItemExists
        ? [
            ...prevForm.items.filter((item) => item.landingId !== landingId),
            newLanding,
          ]
        : arrayUnion(newLanding);

      await saveFormRecord(session.sessionID, {
        ...prevForm,
        items: updateData,
      });
      await updateDoc(docRef, {
        items: updateData,
        processed: false
      });

      console.log("State successfully written to Firestore!");
      if (nextPage) navigate(nextPage(state));
    } catch (err) {
      console.error("Error writing document to Firestore: ", err);
    }
  }
};

const content = ({ state, setState }) => (
  <ToDoBetter
    state={state}
    setState={setState}
    field={"CF_to_do_better_s21yh"}
  /> // Field ID
);

const nextPage = (props) =>
  `/formulario/cancelacion/confirmacion?uid=${props.uid}`;

const prevPage = (props) => {
  if (props.sessionId && props.prevForm) {
    const prevForm = props.prevForm;
    const lastItem = prevForm.items[prevForm.items.length - 1];
    const lastLandingID = lastItem.landingId;
    if (lastLandingID === "CF_REFERED_PROGRAM") {
      return `/formulario/cancelacion/refiere-gana?uid=${props.uid}`;
    }
  }
  return `/formulario/cancelacion/referidos?uid=${props.uid}`;
};

const fieldsStructure = [
  {
    field: {
      id: "CF_to_do_better_s21yh",
      type: "text",
      ref: "CF_to_do_better",
    },
    metadata: {},
    type: "text",
    text: {
      value: "",
    },
  },
];

const toDoBetterProps = {
  landingId,
  onLoad,
  onSubmit,
  content,
  nextPage,
  prevPage,
  fieldsStructure,
};

export default toDoBetterProps;
